import React, { useEffect, useState } from "react";
import { pdfjs } from "react-pdf";
import { useLocation } from "react-router-dom";
import PdfModal from "../../components/pdf/PdfModal";
import FichesFamille from "./fiches_famille";
import FichesImmo from "./fiches_immo";
import FichesGenerales from "./fiches_generales";
import FichesSocietes from "./fiches_societes";
import "./informations.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function Fiches(props) {
  const location = useLocation();
  const [currentPdf, setCurrentPdf] = useState(null);

  const handleOpenPdf = (pdfUrl) => {
    setCurrentPdf(pdfUrl);
  };

  const handleClosePdf = () => {
    setCurrentPdf(null);
  };

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));

    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.hash]);

  return (
    <div className="globalcontainer">
      <div className="containerInformations">
        <div className="cardInformations">
          <h1 className="cardTitleInformations">FICHES PRATIQUES</h1>

          <h2 className="SubCardTitle">
            A votre disposition en téléchargement, issues de l'ouvrage “ESSENTIEL Taxe des actes”
          </h2>
          <div className="containerGlobalFiches">
            <div className="fiches-sections-grid">
              <FichesImmo onOpenPdf={handleOpenPdf} />
              <FichesFamille onOpenPdf={handleOpenPdf} />
              <FichesSocietes />
              <FichesGenerales onOpenPdf={handleOpenPdf} />
            </div>
          </div>
        </div>
      </div>
      <PdfModal pdfUrl={currentPdf} onClose={handleClosePdf} />
    </div>
  );
}

export default Fiches;
